module.exports = __webpack_public_path__ + "static/media/card.f9adcb3b.png";